import React, { useState, useCallback, useEffect } from 'react';
import { InputOnBlur } from '../Input';
import makeValidNumber from './makeValidNumber';
import makeString from './makeString';

type InputOnBlurOnChange = NonNullable<Parameters<typeof InputOnBlur>[0]['onChange']>;
export type NumberProps = Omit<Parameters<typeof InputOnBlur>[0], 'type' | 'suffix' | 'onChange' | 'value'> & {
  value: number | null;
  onChange: (val: number | null, event?: Parameters<InputOnBlurOnChange>[1]) => void;
  onFocus?: Parameters<typeof InputOnBlur>[0]['onFocus'];
  onBlur?: Parameters<typeof InputOnBlur>[0]['onBlur'];
  suffix?: Parameters<typeof InputOnBlur>[0]['suffix'];
};

const NumberInputOnBlur: React.FC<NumberProps> = ({ onChange, value, ...props }) => {
  const [inputOnBlurValue, setInputOnBlurValue] = useState<number | null>(value ?? null);

  const valueRef = React.useRef(inputOnBlurValue);
  valueRef.current = inputOnBlurValue;

  useEffect(() => {
    setInputOnBlurValue(value ?? null);
  }, [value]);

  const handleChange = useCallback((val: string) => {
    setInputOnBlurValue(makeValidNumber(val));
  }, []);

  const handleBlur = useCallback((asString: string, event: React.FocusEvent<HTMLInputElement> | undefined) => {
    const newValue = makeValidNumber(asString);
    onChange(newValue, event);
  }, [onChange]);

  return (
    <InputOnBlur
      {...props}
      value={makeString(inputOnBlurValue)}
      type="number"
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};

export default NumberInputOnBlur;
